import type { ReactNode } from 'react';
import { useEffect } from 'react';

type Props = { children: ReactNode; onClose: () => void };

export const Modal = ({ children, onClose }: Props) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  return (
    <div className="fixed top-0 bottom-0 right-0 left-0 z-[100] flex flex-col items-stretch justify-center sm:items-center">
      <div onClick={onClose} className="absolute top-0 bottom-0 right-0 left-0 backdrop-blur-sm" />
      <div className="bg-background mx-4 shadow-lg p-4 z-10 sm:max-w-md">{children}</div>
    </div>
  );
};

type ModalTitleProps = {
  title: string;
};

export const ModalTitle = ({ title }: ModalTitleProps) => {
  return <h1 className="text-3xl text-center">{title}</h1>;
};
